/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class SmartCenterDesignerTileSelector implements angular.IComponentOptions {
    templateUrl = "app/components/controls/smartCenterDesigner/smartCenterDesignerTileSelector.component.html";
    bindings: any = {
      tileDefinitions: '<?',
      addTileRequested: '&?',
      tileCategorySelections: '<?',
      selectedTileCategory: '=',
      selectedTileCategoryChanged: '&',
      isDisabled: '<?'
    }
    controller = class SmartCenterDesignerTileSelectorController {
    
      public addTileRequested: Function;

      public selectedTileCategoryChanged: Function;

      public selectedTileCategory: Model.SmartTIleCategoryEnum;

      constructor() { }

      private addTile(tile: Model.SmartTileDefinition): void {
        this.addTileRequested({tileDefinition: tile });
      }

      private onSelectedTileCategoryChanged(): void {
        this.selectedTileCategoryChanged({ tileCategory: this.selectedTileCategory });
      }

    }
  }

  angular.module("meevo.components.controls")
    .component("smartCenterDesignerTileSelector", new SmartCenterDesignerTileSelector());
}
